export default "__VITE_ASSET__97xTcfyS__"